export default "__VITE_ASSET__2eda181c__"